import React from "react";

const STATS = [
  { big: "Small-Group", small: "High-Touch Training" },
  { big: "Game-Realistic", small: "Every Session" },
  { big: "USSF & UEFA", small: "Licensed Coaches" },
  { big: "DeSoto County, MS", small: "& Greater Memphis Area" },
];

export function BrandMarquee() {
  return (
    <div className="relative z-10 border-y border-white/10 bg-obsidian py-8 md:py-10" data-testid="brand-marquee">
      <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-y-8 px-5 md:grid-cols-4 md:px-10">
        {STATS.map((s, i) => (
          <div key={s.small} className={`flex flex-col items-center text-center ${i < STATS.length - 1 ? "md:border-r md:border-white/10" : ""}`}>
            <span className="font-heading text-xl uppercase leading-none tracking-tight text-neon-green sm:text-2xl md:text-3xl">
              {s.big}
            </span>
            <span className="mt-2 font-body text-[10px] font-bold uppercase tracking-[0.25em] text-white/50 sm:text-xs">
              {s.small}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SectionLabel({ children, ...props }) {
  return (
    <div className="mb-4 flex items-center gap-3" {...props}>
      <span className="h-px w-8 bg-neon-green" />
      <span className="font-body text-xs font-bold uppercase tracking-[0.3em] text-neon-green">{children}</span>
    </div>
  );
}
